import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-6 flex flex-col w-full justify-center",
  "data-testid": "test-cancel-tour"
}
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoIcon = _resolveComponent("InfoIcon")!
  const _component_AppModal = _resolveComponent("AppModal")!

  return (_openBlock(), _createBlock(_component_AppModal, {
    id: "parallel-edit-modal",
    visible: _ctx.isErrorModalVisible('updateOrderError'),
    modalType: "accept",
    cancelText: "tour.ok",
    onHideModal: _ctx.close
  }, {
    default: _withCtx(() => [
      (_ctx.isErrorModalVisible('updateOrderError'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_InfoIcon),
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("order.error.update_title")), 1),
            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("order.error.update_text")), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "onHideModal"]))
}